export default function EmptyTasks() {
  return (
    <svg
      width='230'
      height='160'
      viewBox='0 0 230 160'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='115'
        cy='79'
        r='78'
        className='fill-[#EFF6FF] dark:fill-transparent dark:stroke-[#FFDA68]'
      />
      <g clipPath='url(#clip0_4353_154121)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M67.1875 77.0946L84.8706 76.8607C91.7006 80.7981 97.8133 85.8972 103.076 92.3452C116.689 69.7735 132.33 51.2795 149.522 35.8652H162.994C138.957 62.5692 119.34 91.16 103.653 121.443C95.2637 103.456 83.5296 88.3142 67.1875 77.0946Z'
          className='fill-[#3492F6] dark:fill-[#FFDA68] opacity-20 dark:opacity-100'
        />
      </g>
      <defs>
        <clipPath id='clip0_4353_154121'>
          <rect
            width='95.8069'
            height='85.5775'
            fill='white'
            transform='translate(67.1875 35.8652)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
